import angular from 'angular'
import type { ModalFactory } from '../vend-ui/types'

import setCashFloatTemplate from '../components/cash-management/set-cash-float/set-cash-float.html'
import { $q } from '../ng-compat/imports'

/**
 * Provides cash management related modals
 *
 * @module cashManagementModals
 */
angular
  .module('webregister.modals')
  .factory('cashManagementModals', function (Modal: ModalFactory) {
    /**
     * Provides cash management related modals e.g. Add / Remove cash
     *
     * @class CashManagementModals
     * @static
     */
    return {
      /**
       * Open the modal responsible for setting the inital cash float for the register.
       *
       * @method openRegisterSetFloat
       *
       * @return {Promise} A promise resolved once the cash register has been opened and the cash float set.
       */
      openRegisterSetFloat() {
        return $q((resolve, reject) => {
          return Modal<$TSFixMe>({
            template: setCashFloatTemplate,
            controller: 'SetCashFloatController',
            controllerAs: '$ctrl',
          })
            .then(modal => modal.closed)
            .then(result => (result ? resolve(result) : reject()), reject)
        })
      },
    }
  })
